import React from 'react';
import { InputField } from '../UI/InputField';
import { UserIcon, MailIcon, PhoneIcon, MapPinIcon, HomeIcon } from 'lucide-react';
export const Step4ContactDetails = ({
  formData,
  handleInputChange,
  errors,
  touched,
  setTouched
}) => {
  return <div className="mt-4 space-y-6" data-id="element-139">
      <InputField id="naam" label="Naam" placeholder="Uw volledige naam" value={formData.contactDetails.naam} onChange={e => handleInputChange('contactDetails', 'naam', e.target.value)} error={errors.naam} onBlur={() => setTouched(prev => ({
      ...prev,
      'contactDetails.naam': true
    }))} touched={touched['contactDetails.naam']} required icon={<UserIcon className="h-4 w-4" data-id="element-141" />} premium={true} data-id="element-140" />
      <div data-id="element-142">
        <h3 className="text-sm font-medium text-gray-700 mb-4" data-id="element-143">
          Adresgegevens
        </h3>
        <div className="space-y-4" data-id="element-144">
          <InputField id="straat" label="Straat" placeholder="Straatnaam" value={formData.contactDetails.straat || ''} onChange={e => handleInputChange('contactDetails', 'straat', e.target.value)} error={errors.straat} onBlur={() => setTouched(prev => ({
          ...prev,
          'contactDetails.straat': true
        }))} touched={touched['contactDetails.straat']} required icon={<MapPinIcon className="h-4 w-4" data-id="element-146" />} premium={true} data-id="element-145" />
          <div className="grid grid-cols-2 gap-4" data-id="element-147">
            <InputField id="huisnummer" label="Huisnummer" placeholder="123" value={formData.contactDetails.huisnummer || ''} onChange={e => handleInputChange('contactDetails', 'huisnummer', e.target.value)} error={errors.huisnummer} onBlur={() => setTouched(prev => ({
            ...prev,
            'contactDetails.huisnummer': true
          }))} touched={touched['contactDetails.huisnummer']} required icon={<HomeIcon className="h-4 w-4" data-id="element-149" />} premium={true} data-id="element-148" />
            <InputField id="toevoeging" label="Toevoeging" placeholder="A, B, etc." value={formData.contactDetails.toevoeging || ''} onChange={e => handleInputChange('contactDetails', 'toevoeging', e.target.value)} premium={true} data-id="element-150" />
          </div>
          <div className="grid grid-cols-3 gap-4" data-id="element-151">
            <div className="col-span-1" data-id="element-152">
              <InputField id="postcode" label="Postcode" placeholder="1234 AB" value={formData.contactDetails.postcode || ''} onChange={e => handleInputChange('contactDetails', 'postcode', e.target.value)} error={errors.postcode} onBlur={() => setTouched(prev => ({
              ...prev,
              'contactDetails.postcode': true
            }))} touched={touched['contactDetails.postcode']} required premium={true} data-id="element-153" />
            </div>
            <div className="col-span-2" data-id="element-154">
              <InputField id="plaats" label="Plaats" placeholder="Amsterdam" value={formData.contactDetails.plaats || ''} onChange={e => handleInputChange('contactDetails', 'plaats', e.target.value)} error={errors.plaats} onBlur={() => setTouched(prev => ({
              ...prev,
              'contactDetails.plaats': true
            }))} touched={touched['contactDetails.plaats']} required premium={true} data-id="element-155" />
            </div>
          </div>
        </div>
      </div>
      <div data-id="element-156">
        <h3 className="text-sm font-medium text-gray-700 mb-4" data-id="element-157">
          Contactgegevens
        </h3>
        <div className="space-y-4" data-id="element-158">
          <InputField id="emailadres" label="E-mailadres" type="email" placeholder="uw@email.nl" value={formData.contactDetails.emailadres} onChange={e => handleInputChange('contactDetails', 'emailadres', e.target.value)} error={errors.emailadres} onBlur={() => setTouched(prev => ({
          ...prev,
          'contactDetails.emailadres': true
        }))} touched={touched['contactDetails.emailadres']} required icon={<MailIcon className="h-4 w-4" data-id="element-160" />} premium={true} data-id="element-159" />
          <InputField id="telefoonnummer" label="Telefoonnummer" type="tel" placeholder="06 12345678" value={formData.contactDetails.telefoonnummer} onChange={e => handleInputChange('contactDetails', 'telefoonnummer', e.target.value)} error={errors.telefoonnummer} onBlur={() => setTouched(prev => ({
          ...prev,
          'contactDetails.telefoonnummer': true
        }))} touched={touched['contactDetails.telefoonnummer']} required icon={<PhoneIcon className="h-4 w-4" data-id="element-162" />} premium={true} data-id="element-161" />
        </div>
      </div>
    </div>;
};